<template>
  <section>
    <section class="grid-flex column">
      <div class="box flex-1 w100">
        <div v-show="false" class="box-title">
          <div class="flex middle">
            <div class="flex-1">
              <h3>VSL</h3>
            </div>
          </div>
        </div>
        <div class="box-content ">
          <div class="flex-1 ">
            <div class="flex  middle">
              <!-- form -->
              <validation-observer
                ref="form"
                v-slot="{ handleSubmit }"
                class="w100"
              >
                <form @submit.prevent="handleSubmit(createVsl)">
                  <div class="flex-1 w100">
                    <validation-provider
                      name="titulo"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-field group-input margin-top-s"
                        :class="{ errors: errors[0] }"
                      >
                        Titulo
                        <input
                          type="text"
                          v-model="vsl.title"
                          placeholder="Titulo"
                        />
                        <span class="erros-alert">{{ errors[0] }}</span>
                      </div>
                    </validation-provider>
                  </div>
                  <div class="flex-1 margin-top-l">
                    <p>Video:</p>
                    <form class="margin-top-l">
                      <div
                        class="upload-area"
                        @click="!loaderFile && $refs.fileInput.click()"
                      >
                        <label
                          v-if="!loaderFile && !successFile"
                          class="placeholder"
                          style="cursor:pointer"
                        >
                          <i class="fas fa-cloud-upload-alt"></i>
                          <span>Fazer upload do VIDEO</span>
                        </label>
                        <label
                          v-if="successFile"
                          class="placeholder"
                          style="cursor:pointer"
                        >
                          <i class="fas fa-cloud-upload-alt"></i>
                          <p>
                            Seu arquivo de VIDEO já está em nossos servidores e
                            está sendo processado...
                          </p>
                        </label>
                        <input
                          ref="fileInput"
                          type="file"
                          @change="uploadFile"
                          style="display: none"
                        />
                        <div v-if="loaderFile">
                          <p>Enviando arquivo...</p>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div class="flex-1 margin-top-l">
                    <validation-provider
                      name="url do checkout"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-field group-input margin-top-s"
                        :class="{ errors: errors[0] }"
                      >
                        Url do checkout
                        <input
                          type="text"
                          v-model="vsl.url_checkout"
                          placeholder="url do checkout"
                        />
                        <span class="erros-alert">{{ errors[0] }}</span>
                      </div>
                    </validation-provider>
                  </div>
                  <div class="flex-1 flex margin-top-l">
                    <div class="flex-1">
                      <validation-provider
                        name="texto botão checkout"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <div
                          class="form-field group-input margin-top-s"
                          :class="{ errors: errors[0] }"
                        >
                          Texto botão checkout
                          <input
                            type="text"
                            v-model="vsl.text_button_checkout"
                            placeholder="texto botão checkout"
                          />
                          <span class="erros-alert">{{ errors[0] }}</span>
                        </div>
                      </validation-provider>
                    </div>
                    <div class="flex-1">
                      <validation-provider
                        name="cor do botão de checkout"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <div
                          class="form-field group-input margin-top-s margin-left"
                          :class="{ errors: errors[0] }"
                        >
                          Cor do botão de checkout
                          <input
                            type="color"
                            v-model="vsl.color_button_checkout"
                            placeholder="#68d588"
                            style="padding: 0px;"
                          />
                          <span class="erros-alert">{{ errors[0] }}</span>
                        </div>
                      </validation-provider>
                    </div>
                    <div class="flex-1">
                      <validation-provider
                        name="tempo para mostrar botão de compra"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <div
                          class="form-field group-input margin-top-s margin-left"
                          :class="{ errors: errors[0] }"
                        >
                          Segundos para mostrar o botão de compra
                          <input
                            type="number"
                            v-model="vsl.time_to_show_button_checkout"
                            placeholder="tempo para mostrar botão de compra"
                          />
                          <span class="erros-alert">{{ errors[0] }}</span>
                        </div>
                      </validation-provider>
                    </div>
                  </div>

                  <div class="flex">
                    <div class="flex-1">
                      <validation-provider
                        name="auto play"
                        rules=""
                        v-slot="{ errors }"
                      >
                        <div
                          class="form-field group-input margin-top-s margin-left"
                          :class="{ errors: errors[0] }"
                        >
                          <input
                            type="checkbox"
                            v-model="vsl.autoplay"
                            class="my-checkbox"
                          />
                          Auto Play
                          <span class="erros-alert">{{ errors[0] }}</span>
                        </div>
                      </validation-provider>
                    </div>

                    <div class="flex-1">
                      <validation-provider
                        name="auto play"
                        rules=""
                        v-slot="{ errors }"
                      >
                        <div
                          class="form-field group-input margin-top-s margin-left"
                          :class="{ errors: errors[0] }"
                        >
                          <input
                            type="checkbox"
                            v-model="vsl.progress_bar"
                            class="my-checkbox"
                          />
                          Progresso Inteligente
                          <span class="erros-alert">{{ errors[0] }}</span>
                        </div>
                      </validation-provider>
                    </div>

                    <div class="flex-1">
                      <validation-provider
                        name="auto play"
                        rules=""
                        v-slot="{ errors }"
                      >
                        <div
                          class="form-field group-input margin-top-s margin-left"
                          :class="{ errors: errors[0] }"
                        >
                          <input
                            type="checkbox"
                            class="my-checkbox"
                            v-model="vsl.return_progress"
                          />
                          Continuar Assistindo
                          <span class="erros-alert">{{ errors[0] }}</span>
                        </div>
                      </validation-provider>
                    </div>
                  </div>

                  <div class="flex margin-top-l">
                    <router-link
                      :to="{
                        name: 'VSL',
                        params: {},
                      }"
                    >
                      <div class="button secondary medium">Voltar</div>
                    </router-link>
                    <button
                      type="submit"
                      class="button primary"
                      style="margin-left: 8px"
                    >
                      Salvar
                    </button>
                  </div>
                </form>
              </validation-observer>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import { Upload } from "@/services/upload";
import { createVsl, updateVsl, getVsl, deleteVsl } from "@/services/vsl";

export default {
  name: "edit-vsl",
  components: {},
  props: ["vsl_id"],
  data() {
    return {
      loading: false,
      loaderFile: false,
      successFile: null,
      tmpFileName: "",
      vsl: {
        title: "",
        time_to_show_button_checkout: 780,
        text_button_checkout: "GARANTIR OFERTA",
        url_checkout: "",
        color_button_checkout: "#68d588",
        progress_bar: true,
        autoplay: true,
        return_progress: true,
      },
    };
  },
  methods: {
    createVsl() {
      let vsl = this.vsl;

      vsl.file_name = this.tmpFileName;

      createVsl(this.vsl)
        .then((result) => {
          console.log("result", result);
          this.$toast.success({
            title: "Sucesso",
            message: "Vsl criada com sucesso",
          });

          this.$router.push({ name: "VSL" });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falhou ao criar vsl",
          });
        });
    },
    updateVsl() {
      updateVsl(this.vsl_id, this.vsl)
        .then((result) => {
          console.log("result", result);
          this.$toast.success({
            title: "Sucesso",
            message: "Vsl criada com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falhou ao criar vsl",
          });
        });
    },
    deleteVsl() {
      deleteVsl(this.vsl_id)
        .then((result) => {
          console.log("result", result);
          this.$toast.success({
            title: "Sucesso",
            message: "Vsl criada com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falhou ao criar vsl",
          });
        });
    },
    getVsl() {
      getVsl(this.vsl_id)
        .then((result) => {
          console.log("result", result);
          this.$toast.success({
            title: "Sucesso",
            message: "Vsl criada com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falhou ao criar vsl",
          });
        });
    },
    uploadFile() {
      this.file = this.$refs.fileInput.files[0];
      const types = [
        "application/csv",
        "text/csv",
        ".csv",
        "text/comma-separated-values",
      ];

      // TODO: Validar se esse dois metodos não vão apresentar problemas
      if (!types.includes(this.file.type) && !this.file.name.includes(".mp4")) {
        return this.$toast.error({
          title: "Erro",
          message: "O formato do arquivo deve ser csv",
        });
      }

      this.loaderFile = true;
      Upload(this.content, this.file, "mp4")
        .then((response) => {
          this.successFile = true;
          // this.csv = this.file.name;

          this.tmpFileName = response.file_name;

          this.$toast.success({
            title: "Sucesso",
            message: "Upload realizado com sucesso",
          });
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }

          this.$toast.error({
            title: "Erro",
            message: "Falha ao fazer upload.",
          });
        })
        .finally(() => {
          this.loaderFile = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.margin-left {
  margin-left: 10px;
}

.upload-area {
  cursor: pointer;
}

.my-checkbox {
  width: 20px !important;
  height: 20px !important;
}
</style>
